export default {
    brand: "品牌：",
    goodsSn: "商品編號：",
    personalSn: "您的編號：",
    price: "您的價格：",
    stock: "商品庫存：",
    color: "顏色分類：",
    spec: "規格分類：",
    num: "訂購數量：",
    addcart: "加入購物車",
    addqcart: "加入報價車",
    collection1: "收藏",
    collection2: "取消收藏",
    collection3: "收藏成功！",
    collection4: "取消收藏成功！",
    colormsg: "請選擇顏色屬性！",
    specmsg: "請選擇規格屬性！",
    addSucc: "添加成功！",
    notPower: "您還沒有權限購買此商品，請聯繫管理員！",
    detail: "詳情描述",
    notdetail: "暫無詳情描述",
}